import React from "react";
import { Nav } from "./app/components/navigation";
import { ProvideAlert } from "./app/hooks/useAlert";
import { Toaster } from "sonner";

function Environment() {
  if (process.env.NODE_ENV !== "production") {
    return (
      <p>You are running this application in {process.env.NODE_ENV} mode.</p>
    );
  }
  return <></>;
}

const App: React.FC = () => {
  return (
    <ProvideAlert>
      <div className="App bg-white">
        <Nav />
        <Environment />
        <Toaster richColors />
      </div>
    </ProvideAlert>
  );
};

export default App;
